import { useMutation, useQueryClient } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { real_estate_api } from '@axo/shared/data-access/api';
import { realEstateKeys } from '../../cache-keys/realEstateKeys';

export function useRemoveApplicationCollateral() {
  const api = useAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: real_estate_api.removeLoanApplicationCollateral(api),
    onSettled: async () => {
      queryClient.removeQueries([realEstateKeys.root()]);
    },
  });
}
